<template>
    <form class="max-w-4xl">
        <div class="grid grid-cols-1 gap-x-8 gap-y-6" v-if="item">
            <form-field-checkbox
                id="event-featured"
                label="Featured Event"
                field="event_featured"
                :value="item.event_featured"
                @update="updateEventField"
            ></form-field-checkbox>
            <form-field-text
                id="event-title"
                label="Title"
                field="event_title"
                :value="item.event_title"
                @update="updateEventField"
            ></form-field-text>
            <form-field-text
                id="event-slug"
                label="Slug"
                field="event_slug"
                :value="item.event_slug"
                @update="updateEventField"
            ></form-field-text>
            <form-field-date
                id="event-date"
                label="Last Date"
                field="event_date"
                :value="item.event_date"
                @update="updateEventField"
            ></form-field-date>
            <form-field-text
                id="event-city"
                label="City"
                field="event_city"
                :value="item.event_city"
                @update="updateEventField"
            ></form-field-text>
            <form-field-text
                id="event-state"
                label="State"
                field="event_state"
                :value="item.event_state"
                @update="updateEventField"
            ></form-field-text>
            <form-field-text
                id="event-website"
                label="Website"
                field="event_website"
                :value="item.event_website"
                @update="updateEventField"
            ></form-field-text>
            <form-field-text
                id="event-image"
                label="Image URL"
                field="event_image"
                :value="item.event_image"
                @update="updateEventField"
            ></form-field-text>
            <form-field-text
                id="event-jumbo"
                label="Jumbo Image URL"
                field="event_jumbo"
                :value="item.event_jumbo"
                @update="updateEventField"
            ></form-field-text>
            <form-field-text
                id="event-video"
                label="Video URL"
                field="event_video"
                :value="item.event_video"
                @update="updateEventField"
            ></form-field-text>
            <form-field-text-rich
                id="event-description"
                label="Description"
                field="event_description"
                :value="item.event_description"
                @update="updateEventField"
            ></form-field-text-rich>
        </div>
        <div class="mt-10">
            <alert-error class="-mt-4 mb-5" :alert="error" :onDismiss="clearError"></alert-error>
            <div class="flex flex-row">
                <button-primary buttonText="Save" :buttonDisabled="disabled" :buttonClick="putEvent"></button-primary>
            </div>
        </div>
    </form>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'FormEventEdit',
    computed: {
        ...mapState(useStoreEvent, {
            item: 'item',
            disabled: 'disabled',
            error: 'error',
        }),
    },
    methods: {
        ...mapActions(useStoreEvent, {
            updateEventField: 'updateEventField',
            putEvent: 'putEvent',
            clearError: 'clearError',
        }),
    },
};
</script>
